import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {useDomainMonitorPause} from 'features/domain/model/useDomainMonitorMutations';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import IDomainMonitorOutput from 'features/domain/model/DomainMonitor/IDomainMonitor';

interface IDomainMonitorPauseModalProps {
    item: IDomainMonitorOutput,
    open: boolean;
    handleClose: () => void;
}

const DomainMonitorPauseModal: React.FC<IDomainMonitorPauseModalProps> = ({item, open, handleClose}) => {
    const {pause: onClickPause, isLoading} = useDomainMonitorPause({item, handleClose});

    return (
        <ConfirmModal
            variant="pause"
            open={open}
            handleClose={handleClose}
            header={t`Приостановка монитора домена`}
            title={
                <Trans
                    id="modal.domainMonitor.pause.title"
                    message="Вы уверены, что хотите приостановить монитор домена"
                />
            }
            name={item.domain_human_readable}
            confirmText={t`Приостановить`}
            onConfirm={onClickPause}
            isLoading={isLoading}
        />
    );
};

export default DomainMonitorPauseModal;
